// let logoutTimeout;
// let lastExpires;

const configureSessionWatcher = (dispatch) => {
  // const handler = (response) => {
  //   if (!response.status || !String(response.status).match(/(2..|401)/) || !response.headers.has("X-Session-Expires-In")) {
  //     return response;
  //   }
  //   const sessionExpiresIn = response.headers.get("X-Session-Expires-In");
  //   if (sessionExpiresIn !== lastExpires) {
  //     if (logoutTimeout) clearTimeout(logoutTimeout);
  //     if (sessionExpiresIn !== "expired") {
  //       dispatch({
  //         type: "SET_SESSION_EXPIRES",
  //         sessionExpiresIn,
  //       });
  //       logoutTimeout = setTimeout(() => {
  //         dispatch({
  //           type: "SET_SESSION_EXPIRED",
  //         });
  //         window.location.href = "/auth/login?session_expired";
  //       }, sessionExpiresIn);
  //       // Site.sess_update(sessionExpiresIn);
  //     } else {
  //       dispatch({
  //         type: "SET_SESSION_EXPIRED",
  //       });
  //       // Site.sess_update(0);
  //       if (lastExpires !== undefined) {
  //         // RELOGIN REQUIRED - redirect to there
  //         window.location.href = "/auth/login?session_expired";
  //       }
  //     }
  //     lastExpires = sessionExpiresIn;
  //   }
  //   return response;
  // };
  // const composeFetchHandlers = ({
  //   HEAD: handler,
  //   GET: handler,
  //   PUT: handler,
  //   POST: handler,
  //   PATCH: handler,
  //   DELETE: handler,
  // });
};

export default configureSessionWatcher;
